// IOL (Italia Online) tracking.
export const pageview = () => {
  if (!window.iat) return;
  window.iat.send();
};
